import { type PropsWithChildren } from "react"
import { useSafeContext } from "@oefr/hooks"
import { createNamedContext } from "@/utils/create-named-context"

type ActionsContextValue = {
    loading: boolean
    step: boolean
}

const ActionsContext = createNamedContext<ActionsContextValue>("ActionsContext")

interface Props extends PropsWithChildren {
    value: ActionsContextValue
}

export function ActionsProvider({ children, value }: Props) {
    return <ActionsContext.Provider value={value}>{children}</ActionsContext.Provider>
}

export function useActionsContext() {
    return useSafeContext(ActionsContext)
}
